export default {
  title: "Incidence Logs",
  apply_next_status: "Apply next status",
  title_form: "Next status",
  subtitle_form: "Date for the status:",
  text_today: "Today, ",
  button_choose: "Choose a different day",
  next: "Next",
};
